import { Link } from "react-router-dom";
import { mangaWorks } from "@/mocks/manga";

export default function Trending() {
  const trending = mangaWorks.filter((w) => w.trending);
  const rankClass = ["text-primary-500", "text-accent-500", "text-foreground-700", "text-foreground-600", "text-foreground-500"];

  return (
    <section className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <div className="mb-9 flex items-end justify-between">
        <div>
          <p className="inline-flex items-center gap-2 text-sm text-primary-500">
            <i className="ri-fire-line"></i> 热门追更
          </p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
            大家都在追的冬日连载
          </h2>
        </div>
        <span className="hidden text-sm text-foreground-600 sm:block">每周更新热度榜</span>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-5">
        {trending.map((w, idx) => (
          <Link
            key={w.id}
            to={`/work/${w.id}`}
            className="group relative flex flex-row items-center gap-4 overflow-hidden rounded-lg border border-background-200/60 bg-background-100 p-3 transition-all duration-300 hover:-translate-y-1 hover:border-primary-500/40 lg:flex-col lg:items-stretch lg:gap-0 lg:p-0"
          >
            <span className={`shrink-0 font-heading text-4xl font-black ${rankClass[idx]}`}>
              {idx + 1}
            </span>
            <div className="min-w-0 flex-1 lg:p-4">
              <h3 className="truncate font-heading text-base font-bold text-foreground-950 group-hover:text-primary-500">{w.title}</h3>
              <p className="mt-1 text-xs text-foreground-500">{w.categoryName} · {w.status}</p>
              <div className="mt-2 flex items-center gap-3 text-xs text-foreground-600">
                <span className="inline-flex items-center gap-1"><i className="ri-star-fill text-primary-500"></i>{w.rating.toFixed(1)}</span>
                <span className="inline-flex items-center gap-1"><i className="ri-eye-line"></i>{w.views}</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}